/*
 * Lightora : offre professionnelle
 * 1. Message discret dans le panier, au-dela du seuil regle dans la section "Offre pro : panier" (en-tete).
 * 2. Preremplissage du formulaire de devis depuis une fiche produit ou le panier.
 * Rien ici ne touche au bouton de paiement : en cas d'erreur, le message ne s'affiche simplement pas.
 */
(function () {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const NUDGE_CLASS = 'lt-pro-cart-nudge';
  const CART_TARGETS = [
    { selector: '.kaching-cart__footer', position: 'afterbegin' },
    { selector: '#main-cart-footer .cart__blocks', position: 'beforeend' },
    { selector: '#CartDrawer .drawer__footer', position: 'afterbegin' },
  ];

  function getCart() {
    return fetch(`${root}cart.js`, { credentials: 'same-origin' }).then((response) => response.json());
  }

  // Les lignes techniques de personnalisation (_for) ne sont pas des luminaires
  function isLuminaire(item) {
    return !(item.properties && item.properties._for);
  }

  function countLuminaires(cart) {
    return cart.items.filter(isLuminaire).reduce((total, item) => total + item.quantity, 0);
  }

  function initCartNudge() {
    const config = window.lightoraPro;
    if (!config) return;

    let qualifies = false;
    let signature = null;
    let timer = null;

    function cartSignature() {
      return ['.kaching-cart__heading', '.kaching-cart__subtotal', '#cart-icon-bubble']
        .map((selector) => {
          const element = document.querySelector(selector);
          return element ? element.textContent.trim() : '';
        })
        .join('|');
    }

    function buildNudge() {
      const link = document.createElement('a');
      const text = document.createElement('span');
      const label = document.createElement('span');
      link.className = NUDGE_CLASS;
      link.href = config.url;
      text.textContent = config.text;
      label.className = `${NUDGE_CLASS}__label`;
      label.textContent = config.linkLabel;
      link.append(text, label);
      return link;
    }

    function render() {
      CART_TARGETS.forEach(({ selector, position }) => {
        const target = document.querySelector(selector);
        if (!target) return;
        const existing = target.querySelector(`.${NUDGE_CLASS}`);
        if (qualifies && !existing) target.insertAdjacentElement(position, buildNudge());
        if (!qualifies && existing) existing.remove();
      });
    }

    function sync() {
      const current = cartSignature();
      if (current === signature) {
        render();
        return;
      }
      signature = current;
      getCart()
        .then((cart) => {
          qualifies = countLuminaires(cart) >= config.minItems && cart.total_price >= config.minTotal;
          render();
        })
        .catch(() => {});
    }

    function schedule() {
      clearTimeout(timer);
      timer = setTimeout(sync, 300);
    }

    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    schedule();
  }

  // La variante et la quantite choisies sont lues au moment du clic
  function initProductLink() {
    document.addEventListener('click', (event) => {
      const link = event.target.closest('[data-lt-quote-link]');
      if (!link) return;
      const variant = document.querySelector('product-form form input[name="id"]');
      const quantity = document.querySelector('.product-form__quantity input[name="quantity"]');
      const url = new URL(link.href);
      if (variant && variant.value) url.searchParams.set('variante', variant.value);
      if (quantity && Number(quantity.value) > 1) url.searchParams.set('quantite', quantity.value);
      link.href = url.toString();
    });
  }

  function initQuoteForm() {
    const form = document.getElementById('LtDevisForm');
    if (!form) return;

    const params = new URLSearchParams(window.location.search);
    const refs = form.querySelector('[data-lt-refs]');
    const quantitySelect = form.querySelector('[data-lt-quantity]');
    const source = form.querySelector('[data-lt-source]');
    const cartLink = form.querySelector('[data-lt-cart-link]');
    const cartBox = form.querySelector('[data-lt-cart]');
    const cartText = form.querySelector('[data-lt-cart-text]');
    const cartButton = form.querySelector('[data-lt-cart-add]');

    if (!refs) return;
    if (source) source.value = params.get('source') || 'direct';

    function addLines(lines) {
      const existing = refs.value.split('\n').filter(Boolean);
      lines.forEach((line) => {
        if (!existing.includes(line)) existing.push(line);
      });
      refs.value = existing.join('\n');
    }

    function setQuantity(units) {
      if (!quantitySelect) return;
      Array.from(quantitySelect.options).forEach((option) => {
        if (option.dataset.min && units >= Number(option.dataset.min)) quantitySelect.value = option.value;
      });
    }

    function applyCart(cart) {
      const items = cart.items.filter(isLuminaire);
      addLines(
        items.map((item) => {
          const variant = item.variant_title ? ` - ${item.variant_title}` : '';
          return `${item.quantity} x ${item.product_title}${variant}`;
        })
      );
      setQuantity(countLuminaires(cart));
      if (cartLink) {
        const lines = cart.items.map((item) => `${item.variant_id}:${item.quantity}`).join(',');
        cartLink.value = `${window.location.origin}${root}cart/${lines}`;
      }
      if (cartBox) cartBox.hidden = true;
    }

    const handle = params.get('produit');
    if (handle) {
      fetch(`${root}products/${encodeURIComponent(handle)}.js`)
        .then((response) => response.json())
        .then((product) => {
          const quantity = Number(params.get('quantite')) || 1;
          const variant = product.variants.find((item) => String(item.id) === params.get('variante'));
          const detail = variant && variant.title !== 'Default Title' ? ` - ${variant.title}` : '';
          addLines([`${quantity} x ${product.title}${detail}`]);
          if (quantity > 1) setQuantity(quantity);
        })
        .catch(() => {});
    }

    getCart()
      .then((cart) => {
        const units = countLuminaires(cart);
        if (!units) return;
        if (params.get('source') === 'panier') {
          applyCart(cart);
          return;
        }
        if (!cartBox || !cartText || !cartButton) return;
        cartText.textContent = `Votre panier contient ${units} ${units > 1 ? 'articles' : 'article'}.`;
        cartBox.hidden = false;
        cartButton.addEventListener('click', () => applyCart(cart));
      })
      .catch(() => {});
  }

  function init() {
    initCartNudge();
    initProductLink();
    initQuoteForm();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
